(function () {
    'use strict';

    angular.module('GorillaBoy.shareModal')
    .directive('gbTimepicker', ['$parse', '$log', '$translate', '$rootScope', 'gbTimepickerConfig', 'SourceConstant',
        function ($parse, $log, $translate, $rootScope, timepickerConfig, SourceConstant) {
        return {
            restrict: 'EA',
            require:'?^ngModel',
            replace: true,
            scope: {},
            templateUrl: './share-modal/timepicker.html',
            link: function(scope, element, attrs, ngModel) {
                var selected = new Date(),
                    meridians = timepickerConfig.meridians;

                scope.language = $translate.use();

                selected.setHours(timepickerConfig.defaultHour, 0, 0);

                var hourStep = timepickerConfig.hourStep;
                if (attrs.hourStep) {
                    scope.$parent.$watch($parse(attrs.hourStep), function(value) {
                        hourStep = parseInt(value, 10);
                    });
                }

                var minuteStep = timepickerConfig.minuteStep;
                if (attrs.minuteStep) {
                    scope.$parent.$watch($parse(attrs.minuteStep), function(value) {
                        minuteStep = parseInt(value, 10);
                    });
                }

                scope.showMeridian = timepickerConfig.showMeridian;

                scope.meridianToHumanString = function(meridian) {
                     switch (meridian) {
                            case 'AM':
                                return $translate.instant('MERIDIANS.AM');
                            case 'PM':
                                return $translate.instant('MERIDIANS.PM');
                        }
                };

                if (attrs.showMeridian) {
                    scope.$parent.$watch($parse(attrs.showMeridian), function(value) {
                        scope.showMeridian = !!value;

                        if (ngModel.$error.time) {

                            var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
                            if (angular.isDefined(hours) && angular.isDefined(minutes)) {
                                selected.setHours(hours);
                                refresh();
                            }
                        } else {
                            updateTemplate();
                        }
                    });
                }

                function getHoursFromTemplate () {
                    var hours = parseInt(scope.hours, 10);
                    var valid = (scope.showMeridian) ? (hours > 0 && hours < 13) : (hours >= 0 && hours < 24);
                    if (!valid) {
                        return undefined;
                    }

                    if (scope.showMeridian) {
                        if (hours === 12) {
                            hours = 0;
                        }
                        if (scope.meridian === meridians[1]) {
                            hours = hours + 12;
                        }
                    }
                    return hours;
                }

                function getMinutesFromTemplate () {
                    var minutes = parseInt(scope.minutes, 10);
                    return (minutes >= 0 && minutes < 60) ? minutes : undefined;
                }

                function pad (value) {
                    return (angular.isDefined(value) && value.toString().length < 2) ? '0' + value : value;
                }

                var inputs = element.find('input'), hoursInputEl = inputs.eq(0), minutesInputEl = inputs.eq(1);

                var mousewheel = (angular.isDefined(attrs.mousewheel)) ? scope.$eval(attrs.mousewheel) : timepickerConfig.mousewheel;
                if (mousewheel) {
                    var isScrollingUp = function (e) {
                        if (e.originalEvent) {
                            e = e.originalEvent;
                        }

                        var delta = (e.wheelDelta) ? e.wheelDelta : -e.deltaY;
                        return (e.detail || delta > 0);
                    };

                    hoursInputEl.bind('mousewheel wheel', function(e) {
                        if(isScrollingUp(e)) {
                             scope.incrementHours();
                        }
                        else{
                            scope.decrementHours();
                        }
                        e.preventDefault();
                    });

                    minutesInputEl.bind('mousewheel wheel', function(e) {
                        if(isScrollingUp(e)) {
                           scope.incrementMinutes();
                        }
                        else{
                            scope.decrementMinutes();
                        }

                        e.preventDefault();
                    });
                }

                scope.readonlyInput = (angular.isDefined(attrs.readonlyInput)) ? scope.$eval(attrs.readonlyInput) : timepickerConfig.readonlyInput;
                if (!scope.readonlyInput) {
                    var invalidate = function (invalidHours, invalidMinutes) {
                        ngModel.$setViewValue( null );
                        ngModel.$setValidity('time', false);
                        if (angular.isDefined(invalidHours)) {
                            scope.invalidHours = invalidHours;
                        }
                        if (angular.isDefined(invalidMinutes)) {
                            scope.invalidMinutes = invalidMinutes;
                        }
                    };

                    scope.updateHours = function () {
                        var hours = getHoursFromTemplate();

                        if (angular.isDefined(hours)) {
                            selected.setHours(hours);
                            refresh( 'h' );
                        } else {
                            invalidate(true);
                        }
                    };

                    hoursInputEl.bind('blur', function(e) {
                        if (!scope.validHours && scope.hours < 10) {
                            $rootScope.$evalAsync(function() {
                                scope.hours = pad(scope.hours);
                            });
                        }
                    });

                    scope.updateMinutes = function () {
                        var minutes = getMinutesFromTemplate();

                        if ( angular.isDefined(minutes)) {
                            selected.setMinutes(minutes);
                            refresh('m');
                        } else {
                            invalidate(undefined, true);
                        }
                    };

                    minutesInputEl.bind('blur', function(e) {
                        if (!scope.invalidMinutes && scope.minutes < 10) {
                            $rootScope.$evalAsync(function() {
                                scope.minutes = pad(scope.minutes);
                            });
                        }
                    });
                } else {
                    scope.updateHours = angular.noop;
                    scope.updateMinutes = angular.noop;
                }

                ngModel.$render = function () {
                    var date = ngModel.$modelValue ? new Date( ngModel.$modelValue ) : null;
                    if (isNaN(date)) {
                        ngModel.$setValidity('time', false);
                        $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
                    } else {
                        if (date) {
                            selected = date;
                        }
                        makeValid();
                        updateTemplate();
                    }
                };

                function refresh (keyboardChange) {
                    makeValid();
                    ngModel.$setViewValue( new Date(selected) );
                    updateTemplate( keyboardChange );
                }

                function makeValid () {
                    ngModel.$setValidity('time', true);
                    scope.invalidHours = false;
                    scope.invalidMinutes = false;
                }

                function updateTemplate (keyboardChange) {
                    var hours = selected.getHours(), minutes = selected.getMinutes();

                    if (scope.showMeridian) {
                        hours = (hours === 0 || hours === 12) ? 12 : hours % 12;
                    }
                    scope.hours =  keyboardChange === 'h' ? hours : pad(hours);
                    scope.minutes = keyboardChange === 'm' ? minutes : pad(minutes);
                    scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
                }

                function addMinutes(minutes) {
                    var dt = new Date(selected.getTime() + minutes * 60000);
                    selected.setHours(dt.getHours(), dt.getMinutes());
                    refresh();
                }

                scope.incrementHours = function () {
                    addMinutes(hourStep * 60);
                };

                scope.decrementHours = function () {
                    addMinutes(-hourStep * 60);
                };

                scope.incrementMinutes = function () {
                    addMinutes(minuteStep);
                };

                scope.decrementMinutes = function () {
                    addMinutes(-minuteStep);
                };

                scope.toggleMeridian = function () {
                    addMinutes(12 * 60 * ((selected.getHours() < 12) ? 1 : -1));
                };
            }
        };
    }]);
}());
